// 更改手机号
import request from '@/api/request'
/* 修改手机号 */
const changeMobile = (params) => {
  return request({
    url: '/api/v1/cuz/user/mobile/modify',
    method: 'POST',
    data: params,
    domain: 'mallUser'
  })
}
/* 验证旧手机号 */
const verifyMobileWithSms = data =>
  request(
    {
      url: '/api/v1/cuz/user/mobile/verify',
      method: 'POST',
      data,
      domain: 'mallUser'
    }
  )
export default {
  changeMobile,
  verifyMobileWithSms
}
